import { FormArray, FormControl } from '@angular/forms'
import { ContentUnitApiResponse } from '@features/content-unit/models/content-unit.model'

export interface TemplateApiResponse {
  uuid?: string | null;
  title: string;
  description: string;
  tags: string[];
  certificateCategory: string;
  coverageType: string;
  contentUnits: TemplateContentUnitApiResponse[];
}

export interface TemplateForm {
  uuid: FormControl<string | null>;
  title: FormControl<string | null>;
  description: FormControl<string | null>;
  tags: FormControl<string[] | null>;
  certificateCategory: FormControl<string | null>;
  coverageType: FormControl<string | null>;
  contentUnits: FormArray<FormControl<TemplateContentUnit | null>>;
  showDetails: FormControl<boolean | null>;
}

export const CERTIFICATE_CATEGORY_OPTIONS = [
  { label: 'Lease', value: 'LEASE' },
  { label: 'Contractual', value: 'CONTRACTUAL' },
  { label: 'Authorities', value: 'AUTHORITIES' },
  { label: 'Authorities Special Format', value: 'AUTHORITIES_SPECIAL_FORMAT' },
  { label: 'LSG', value: 'LSG' },
  { label: 'Liability', value: 'LIABILITY' },
  { label: 'Property', value: 'PROPERTY' }
]

export interface TemplateContentUnitApiResponse {
  uuid: string;
  condition: string;
  position: number;
}

export interface TemplateContentUnit {
  contentUnit: ContentUnitApiResponse;
  condition: string;
  position: number;
}
